import { extendTheme, defineStyleConfig } from "@chakra-ui/react"

const Text = defineStyleConfig({
  baseStyle: {
    color: "red",
  },
  defaultProps: {},
  variants: {
    regular: {
      color: "green",
    },
  },
})

const theme = extendTheme({
  fonts: {
    heading: `'Rubik', sans-serif`,
    body: `'IBM Plex Sans', sans-serif`,
    monospace: `'IBM Plex Sans', sans-serif`,
  },
  colors: {
    page: {
      bg: "#f3f4f4",
    },
    text: {
      heading: "#516377",
      regular: "#677788",
    },
    components: {
      Text,
    },
  },
})

export default theme
